'use strict';

//Teams service used to communicate Teams REST endpoints
angular.module('teams').factory('AdminData', ['$resource',
	function($resource) {
		return $resource('v1/admin', {
			userId: '@userId'
		}, {
			availablePlans: {
				method: 'GET',
				url : 'v1/admin/available-plans'
			},
			deleteUser: {
				method: 'DELETE',
				url : '/v1/admin/user/:userId'
			},
			getUsers: {
				method: 'GET',
				url : 'v1/admin/users',
				isArray : true
			},
			userInfo: {
				method: 'GET',
				url : 'v1/admin/user-info/:userId'
			},
			changeUserLock: {
				method: 'POST',
				url : 'v1/admin/change-user-lock/:userId'
			},
			changeUserSubscription: {
				method: 'POST',
				url : 'v1/admin/change-user-subscription/:userId'
			},
			changeUserOverrides: {
				method: 'POST',
				url : 'v1/admin/change-user-overrides/:userId'
			},
			chargeUser: {
				method: 'POST',
				url : 'v1/admin/charge-user/:userId'
			},
			getHistoricData: {
				method: 'GET',
				url : 'v1/admin/get-historic-data/:userId'
			},
			updateUser: {
				method: 'POST',
				url : 'v1/admin/update-user/:userId'
			},
			getAllMTProfiles: {
				method: 'GET',
				url: '/v1/mtprofile',
				isArray: true
			},
			getUserMtProfiles: {
				method: 'GET',
				url: '/v1/mtprofile/user/:userId/mtprofile',
				isArray: true
			},
			setUserMtProfile: {
				method: 'POST',
				url: '/v1/mtprofile/user/:userId/mtprofile'
			},
			deleteUserMtProfile: {
				method: 'DELETE',
				url: '/v1/mtprofile/user/:userId/mtprofile'
			}
		});
	}
]);
